import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

import { shouldRenderSubsteps } from '../../hooks/utils/stepValidation';
import { STEP_STATE, WIZARD_PROGRESS } from '../../lib/constants';

const StatusBadge = ({
  step,
  isFirstStep,
  isLastStep,
  stepNumber,
  sidebarType = 'default',
  isRestricted = false,
  onExpandStep,
  onCollapseStep,
  onActivateStep
}) => {
  const { status, state_status } = step;
  const expanded = state_status === STEP_STATE.EXPANDED;
  const hasMultiple = shouldRenderSubsteps(step);
  const isDone = status === WIZARD_PROGRESS.COMPLETED || status === WIZARD_PROGRESS.CONFIRMED;
  const isInProgress = status === WIZARD_PROGRESS.IN_PROGRESS;
  const isNumericSidebar = sidebarType === 'numberic' || sidebarType === 'numeric';
  const handleActivateStep = () => {
    if (!isRestricted) {
      onActivateStep(step.code);
    }
  };

  const handleToggleStep = () => {
    if (isRestricted) return;

    if (expanded) {
      onCollapseStep(step.code);
    } else {
      onExpandStep(step.code);
    }
  };

  const renderMarker = () => {
    if (isNumericSidebar) {
      return stepNumber;
    }

    return isDone ? (
      <Icon icon="check-linear" color="neutral" shade={50} />
    ) : (
      <div
        className={cn(
          'h-2.5 w-2.5 rounded-full border border-solid border-neutral-700 bg-white',
          isInProgress && 'border-warning-600 bg-warning-600',
          step.active && !isInProgress && 'border-primary-500 bg-primary-500'
        )}
      />
    );
  };
  return (
    <>
      {(!isLastStep || (isLastStep && expanded && hasMultiple)) && (
        <div className="absolute left-3 top-6 h-16 w-px bg-neutral-200" />
      )}
      {isFirstStep && <div className="absolute bottom-6 left-3 z-[1] h-3 w-px bg-neutral-200" />}
      <div
        onClick={handleActivateStep}
        className={cn(
          'relative z-10 flex-shrink-0 cursor-pointer items-center',
          isRestricted && 'cursor-not-allowed'
        )}>
        <div
          className={cn(
            'flex h-6 w-6 items-center justify-center rounded-full border border-solid border-neutral-400 bg-white text-white',
            isNumericSidebar && 'text-sm font-500 leading-none text-white',
            isInProgress && 'border-warning-500 text-warning-500',
            isDone && 'border-none bg-success-500',
            step.active && !isDone && !isInProgress && 'border-primary-500',
            isRestricted && ' border-neutral-300 opacity-50',
            !isDone && (isRestricted || isNumericSidebar) && 'text-neutral-400'
          )}>
          {renderMarker()}
        </div>
      </div>
      <div
        onClick={handleActivateStep}
        className={cn('min-w-0 flex-1 cursor-pointer', isRestricted && 'cursor-not-allowed')}>
        <h3
          className={cn(
            'text-sm font-medium leading-snug text-neutral-900',
            step.active && 'font-semibold text-primary-500',
            isDone && step.active && 'text-success-500',
            isInProgress && step.active && 'text-warning-500',
            isRestricted && 'text-neutral-400'
          )}>
          {step.name}
        </h3>
      </div>
      <div>
        {hasMultiple && (
          <Icon
            className={cn(isRestricted ? 'cursor-not-allowed' : 'cursor-pointer')}
            onClick={handleToggleStep}
            color="neutral"
            shade={700}
            icon={
              state_status === STEP_STATE.COLLAPSED
                ? 'chevron-down-2-linear'
                : 'chevron-up-2-linear'
            }
          />
        )}
      </div>
    </>
  );
};

export default StatusBadge;
